import { render } from "./ProductDetail.vue?vue&type=template&id=5be54e7f&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=5be54e7f&lang=css"
import "./ProductDetail.vue?vue&type=style&index=1&id=5be54e7f&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be54e7f"]])

export default __exports__